export default __webpack_public_path__ + "static/media/abld_inverted_reading.5bf60665e5da07be4e30609b650d9f07.svg";